import ClosableModal from "@components/closable-modal/closable-modal";
import NotAuthorized from "@features/auth/not-authorized";
import * as React from "react";

import ModalPadding from "./closable-modal/modal-padding";
import ModalTitle from "./modal-title";

function NotAuthenticatedModal({ isVisible, onClose }: { isVisible: boolean; onClose: () => void }) {
  return (
    <>
      <ClosableModal isVisible={isVisible} onRequestClose={onClose}>
        <ModalTitle title="Je bent momenteel niet ingelogd" />
        <ModalPadding>
          <NotAuthorized onPress={onClose} />
        </ModalPadding>
      </ClosableModal>
    </>
  );
}

export default NotAuthenticatedModal;
